import { StateCreator } from 'zustand';
import { Store } from 'src/stores/store.interface';
import { CreateWorkflowDataStore } from './workflowCreateDataStore.interface';
import { APPROVAL_METADATA, DOMAIN_OPTIONS } from 'src/components/createWorkflow/CreateWorkflowConstants';
import { WorkflowIntention } from '@amzn/snow-nxt-workflow-service-typescript-client';

export const defaultCreateWorkflowDataStore = {
	entityType: '',
	workflowName: '',
	workflowDescription: '',
	selectedDomainOptions: DOMAIN_OPTIONS,
	approvalRequiredToStartExecution: false,
	batchExecutionRequired: false,
	canWorkflowAutotriggered: true,
	approversMetadata: APPROVAL_METADATA,
	workflowIntention: WorkflowIntention.CREATE,
	isReRunAllowed: false,
	usableAsSubWorkflow: false,
};

const createWorkflowDataStore: StateCreator<
	Store,
	[],
	[],
	CreateWorkflowDataStore
> = (set) => ({
	...defaultCreateWorkflowDataStore,
	setEntityType: (entityType) => set({ entityType }),
	setIsApprovalRequiredToStartExecution: (approvalRequiredToStartExecution) => set({ approvalRequiredToStartExecution }),
	setWorkflowName: (name) => set({ workflowName: name }),
	setWorkflowDescription: (desc) => set({ workflowDescription: desc }),
	setSelectedDomainOptions: (options) =>
		set({ selectedDomainOptions: options }),
	setCanWorkflowAutotriggered: (canWorkflowAutotriggered) => set({canWorkflowAutotriggered}),
	setApproversMetadata: (desc) => (set({approversMetadata: desc})),
	setIsBatchExecutionRequired: (batchExecutionRequired) => set({ batchExecutionRequired}),
	setWorkflowIntention: (intention) => set({ workflowIntention: intention }),
	setIsReRunAllowed: (isReRunAllowed) => set({ isReRunAllowed }),
	setUsableAsSubWorkflow: (usableAsSubWorkflow) => set({ usableAsSubWorkflow }),
});

export default createWorkflowDataStore;
